module.exports = __webpack_public_path__ + "static/media/Nickainley-Normal.5bd352df.otf";